import { Select, MenuItem, Checkbox, SelectChangeEvent, Typography, SelectProps, Paper } from "@mui/material";
import { UUID } from "crypto";
import { ReactNode, useEffect, useState } from "react";

interface CustomMultipleSelectProps {
    personId: UUID;
    options: Array<{
        id: any;
        name: string;
    }>;
    onChange: (personId: UUID, selected: Array<any>) => Promise<void>;
    defaultValue?: Array<string>;
    disabled?: boolean;
    label?: string;
    name?: string;
    menuHeight?: number;
    onBlur?: (event: any) => void;
    renderValue?: (selected: Array<any>) => ReactNode;
}

export const CustomMultipleSelect = (props: CustomMultipleSelectProps) => {
    const [optionSelected, setOptionSelected] = useState<Array<any>>(props.defaultValue ?? []);

    const handleOnOptionSelectChanged = (event: SelectChangeEvent<typeof optionSelected>) => {
        const value = event.target.value;
        setOptionSelected(typeof value === "string" ? value.split(",") : value);

        const options: Array<any> = typeof value === "string" ? [] : value;
        props.onChange(props.personId, options);
    };

    return (
        <Select
            multiline
            name={props.name}
            label={props.label}
            multiple
            onBlur={props.onBlur}
            onChange={handleOnOptionSelectChanged}
            value={optionSelected}
            renderValue={
                props.renderValue !== undefined
                    ? (value) => props.renderValue?.(value)
                    : (selected: Array<any>) => {
                          const result = selected.map((select) => props.options.find((opt) => opt.id === select)?.name);
                          return result.join(", ");
                      }
            }
            MenuProps={{
                PaperProps: {
                    style: {
                        maxHeight: props.menuHeight,
                    },
                },
            }}
            disabled={props.disabled}
        >
            {props.options.map((option) => (
                <MenuItem value={option.id}>
                    <Checkbox checked={optionSelected.includes(option.id)} size="small" />
                    <Typography color="main2" fontWeight={400}>
                        {option.name}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
    );
};
